/**
 * Labstep
 *
 * @module state/epics/resource-item-template
 * @desc Redux epic for resource-item-template actions
 */

import type { Action } from 'labstep-web/models/action.model';
import { Resource } from 'labstep-web/models/resource.model';
import { readEntities } from 'labstep-web/state/actions/entity';
import { concat, type Observable, of } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';

/**
 * Reload resource after creating a new resource item template.
 *
 * @function
 * @param  {Observable<Action>} action$
 * @param  {StateObservable<LabstepReduxState>} state$
 * @return {Observable<Action>}
 */
export const reloadAfterCreateResourceItemTemplateActionEpic = (
  action$: Observable<Action>,
): Observable<Action> =>
  action$.pipe(
    filter(
      (action: Action) =>
        action.type === 'SUCCESS_CREATE_RESOURCE_ITEM' &&
        action.meta &&
        action.meta.body &&
        (action.meta as any).body.resource_id &&
        (action.meta as any).body.is_template,
    ),
    map((action: Action) =>
      readEntities(Resource.entityName, {
        get_single: 1,
        id: (action.meta as any).body.resource_id,
        is_deleted: 'both',
      }),
    ),
    catchError((err, source$: Observable<Action>) =>
      concat(
        of({
          type: 'EPIC_FAIL_READ_RESOURCE_AFTER_CREATE_RESOURCE_ITEM_TEMPLATE',
          payload: err,
        }),
        source$,
      ),
    ),
  );
